import styled from "styled-components";
import { colors } from "../../../../../../theme/theme";

export const ModalContent = styled.div`
   color: ${colors.greyscale.black};
`